// JsFromRoutes CacheKey 132a6a531ba82a288fdc21e4d10ec147
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const roomSelections = {
  create: definePathHelper("post", "/room_selections"),
};
